import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Scrollbar from "../../components/scrollbar/scrollbar";
import logo from "../../images/logo.avif";

const LinksPage = () => {
  const links = [
    {
      name: "Kit Neuroalfabetização",
      url: "/kit-neuroalfabetizacao/?utm_source=pagina_links&utm_medium=pagina_links&utm_campaign=pagina_links",
      icon: "fa-book",
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/neurodesenvolver.co/?utm_source=pagina_links&utm_medium=pagina_links&utm_campaign=pagina_links",
      icon: "fa-instagram",
    },
    {
      name: "WhatsApp",
      url: "https://wa.me/5581991933883/?utm_source=pagina_links&utm_medium=pagina_links&utm_campaign=pagina_links",
      icon: "fa-whatsapp",
    },
  ];

  return (
    <Fragment>
      <div className="link-page-container">
        <div className="link-page-header">
          <img
            src={logo}
            alt="Neurodesenvolver Logo"
            className="link-page-logo"
          />
          <h1>Instituto Neurodesenvolver</h1>
          <p>Estimulando mentes, transformando futuros.</p>
        </div>

        <div className="link-page-links">
          {links.map((link, index) => (
            <Link
              key={index}
              to={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="theme-btn link-page-button"
            >
              <span className={`fa ${link.icon}`}></span> {link.name}
            </Link>
          ))}
        </div>
        <div className="link-page-footer">
          <Link
            to="https://hub.goadopt.io/document/51802f01-d597-43f0-9f2c-e9ebed6af6f0"
            target="_blank"
            rel="noopener noreferrer"
          >
            Política de Privacidade
          </Link>
          <span className="copyright-icon">|</span>
          <Link
            to="https://hub.goadopt.io/document/bb3664ea-884e-4f13-847a-aa296008385a"
            target="_blank"
            rel="noopener noreferrer"
          >
            Termos de Uso
          </Link>
          <span className="copyright-icon">|</span>
          <Link
            to="https://hub.goadopt.io/document/6fe65eb6-14fd-46fc-b4b5-ed4c518b4321"
            target="_blank"
            rel="noopener noreferrer"
          >
            Política de Cookies
          </Link>
        </div>
      </div>
      <Scrollbar />
    </Fragment>
  );
};

export default LinksPage;
